import React, { useEffect, useRef, useState } from "react";

import ImageCarousel from "../../components/client/ImageCarousel";

import NewsLayout from "../../components/client/NewLayout";

import ButtonTitle from "../../components/ButtonTitle";

import ApiCustom from "../../utils/ApiCustom";

import YouTubePosts from "../../components/client/YoutubePosts";

import HomeMemberRegistrationForm from "../../components/client/HomeMemberRegistrationForm";

import SponsorSlider from "../../components/client/SponsorSlider";

import { MobileAdvertisementSlot } from "../../components/client/AdvertisementDisplay";

let ignore = false;

const getResponseList = (response) => {
  if (Array.isArray(response?.data?.data?.images)) {
    return response.data.data.images;
  }

  if (Array.isArray(response?.data?.data?.data)) {
    return response.data.data.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  return [];
};

const getMemberTypeFromUrl = () => {
  const validTypes = ["company", "individual"];

  const searchParams = new URLSearchParams(window.location.search);
  const typeFromSearch = searchParams.get("type");

  if (validTypes.includes(typeFromSearch)) {
    return typeFromSearch;
  }

  const hash = window.location.hash || "";
  const hashQuery = hash.includes("?") ? hash.split("?")[1] : "";
  const hashParams = new URLSearchParams(hashQuery);
  const typeFromHash = hashParams.get("type");

  if (validTypes.includes(typeFromHash)) {
    return typeFromHash;
  }

  return "company";
};

const isMemberRegisterHash = () => {
  const hash = window.location.hash || "";

  return hash === "#dang-ky" || hash.startsWith("#dang-ky?");
};

function Home() {
  const [adsData, setAdsData] = useState();

  const [mediaCategories, setMediaCategories] = useState([]);

  const [medias, setMedias] = useState([]);

  const [defaultMemberType, setDefaultMemberType] = useState(getMemberTypeFromUrl());

  const memberFormRef = useRef(null);

  const scrollToMemberForm = () => {
    if (memberFormRef.current) {
      const offset = 130;

      const elementPosition =
        memberFormRef.current.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - offset,

        behavior: "auto",
      });
    }
  };

  useEffect(() => {
    if (!sessionStorage.getItem("hasIncreasedView") && !ignore) {
      ApiCustom.post("/views/increase")
        .then(() => {
          sessionStorage.setItem("hasIncreasedView", "1");
        })
        .catch((err) => console.log("Increase view failed", err));
    }

    ignore = true;

    getAds();

    getMediaData();

    const handleHashScroll = () => {
      setDefaultMemberType(getMemberTypeFromUrl());

      if (isMemberRegisterHash()) {
        setTimeout(() => {
          scrollToMemberForm();
        }, 0);

        setTimeout(() => {
          scrollToMemberForm();
        }, 500);
      } else {
        window.scrollTo({ top: 0, behavior: "auto" });
      }
    };

    handleHashScroll();

    window.addEventListener("hashchange", handleHashScroll);

    window.addEventListener("popstate", handleHashScroll);

    return () => {
      window.removeEventListener("hashchange", handleHashScroll);

      window.removeEventListener("popstate", handleHashScroll);
    };
  }, []);

  const getAds = () => {
    ApiCustom.get("product-show-with-priority")
      .then((res) => {
        setAdsData(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  const getMediaData = async () => {
    try {
      const [categoryResponse, imageResponse, videoResponse] =
        await Promise.all([
          ApiCustom.get("/media-category-shows", {
            params: {
              limit: 1000,
            },
          }),

          ApiCustom.get("/get-media-public/thumbnail", {
            params: {
              limit: 1000,
            },
          }),

          ApiCustom.get("/get-media-video-public"),
        ]);

      const categories = getResponseList(categoryResponse);

      const images = getResponseList(imageResponse);

      const videos = getResponseList(videoResponse);

      setMediaCategories(categories);

      setMedias([...images, ...videos]);
    } catch (err) {
      console.log("Get media data failed", err);
    }
  };

  useEffect(() => {
    if (isMemberRegisterHash()) {
      setTimeout(() => {
        scrollToMemberForm();
      }, 0);
    }
  }, [adsData]);

  useEffect(() => {
    const handleScroll = () => {
      scrollToMemberForm();
    };

    window.addEventListener("scrollToMemberForm", handleScroll);

    return () => {
      window.removeEventListener("scrollToMemberForm", handleScroll);
    };
  }, []);

  return (
    <div>
      <div className="md:block hidden">
        <ImageCarousel />
      </div>

      <NewsLayout
        data={adsData}
        adCategories={mediaCategories}
        adMedias={medias}
      />

      <MobileAdvertisementSlot
        positionKey="mobile_after_news"
        categories={mediaCategories}
        medias={medias}
      />

      <YouTubePosts />

      <SponsorSlider categories={mediaCategories} medias={medias} />

      <MobileAdvertisementSlot
        positionKey="mobile_before_register"
        categories={mediaCategories}
        medias={medias}
      />

      <div className=" rounded-md">
        <div className="w-full mx-auto bg-white shadow-xl rounded-xl md:p-8 border border-gray-200">
          <div id="dang-ky" ref={memberFormRef} className="mb-4">
            <ButtonTitle title="Đăng Ký Hội Viên" />
          </div>

          <HomeMemberRegistrationForm
            useId={true}
            defaultMemberType={defaultMemberType}
          />
        </div>
      </div>

      <MobileAdvertisementSlot
        positionKey="mobile_after_register"
        categories={mediaCategories}
        medias={medias}
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3 mb-3"></div>

      <MobileAdvertisementSlot
        positionKey="mobile_footer"
        categories={mediaCategories}
        medias={medias}
      />
    </div>
  );
}

export default Home;